import { render, staticRenderFns } from "./ProjectSelected.vue?vue&type=template&id=0248b30b&scoped=true"
import script from "./ProjectSelected.vue?vue&type=script&lang=js"
export * from "./ProjectSelected.vue?vue&type=script&lang=js"
import style0 from "./ProjectSelected.vue?vue&type=style&index=0&id=0248b30b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248b30b",
  null
  
)

export default component.exports